import { render } from "./GoalGanttChart.vue?vue&type=template&id=3291743f&scoped=true"
import script from "./GoalGanttChart.vue?vue&type=script&lang=js"
export * from "./GoalGanttChart.vue?vue&type=script&lang=js"

import "./GoalGanttChart.vue?vue&type=style&index=0&id=3291743f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3291743f"]])

export default __exports__